import { render } from "./snackbars.vue?vue&type=template&id=ac1b6cee"
import script from "./snackbars.vue?vue&type=script&lang=js"
export * from "./snackbars.vue?vue&type=script&lang=js"

import "./snackbars.vue?vue&type=style&index=0&id=ac1b6cee&lang=css"
script.render = render

export default script